import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, subtitle, lastUpdated, children }) {
  return (
    <main className="bg-[#0A0A0A] text-white font-body min-h-screen">
      {/* Header */}
      <header className="sticky top-0 z-40 bg-black/80 backdrop-blur-md border-b border-white/10">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-zinc-400 hover:text-yellow-400 transition-colors"
            data-testid="legal-back-home"
          >
            <ArrowLeft className="w-4 h-4" />
            <span className="text-xs uppercase tracking-widest">Voltar</span>
          </Link>
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 bg-yellow-400 flex items-center justify-center">
              <span className="text-black font-black text-sm">K</span>
            </div>
            <span className="font-display text-sm tracking-tight uppercase">Kawan Gruista</span>
          </div>
        </div>
      </header>

      <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20">
        <div className="mb-10">
          <div className="text-xs uppercase tracking-[0.3em] text-yellow-400 mb-3">
            Informação Legal
          </div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-4 text-zinc-400 text-lg leading-relaxed">{subtitle}</p>
          )}
          {lastUpdated && (
            <div className="mt-6 text-xs uppercase tracking-widest text-zinc-500">
              Última atualização: {lastUpdated}
            </div>
          )}
        </div>

        <div className="legal-body text-zinc-300 leading-relaxed space-y-6 text-[15px]">
          {children}
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-wrap gap-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-yellow-400 hover:bg-yellow-300 text-black font-display uppercase tracking-widest text-xs px-5 py-3"
            data-testid="legal-cta-home"
          >
            Voltar à página
          </Link>
          <Link
            to="/termos"
            className="inline-flex items-center gap-2 border border-white/10 hover:border-yellow-400/60 text-white uppercase tracking-widest text-xs px-5 py-3"
          >
            Termos de Uso
          </Link>
          <Link
            to="/privacidade"
            className="inline-flex items-center gap-2 border border-white/10 hover:border-yellow-400/60 text-white uppercase tracking-widest text-xs px-5 py-3"
          >
            Política de Privacidade
          </Link>
        </div>
      </article>

      <style>{`
        .legal-body h2 {
          font-family: 'Barlow Condensed', sans-serif;
          font-weight: 800;
          font-size: 1.75rem;
          line-height: 1;
          letter-spacing: -0.01em;
          text-transform: uppercase;
          color: #ffffff;
          margin-top: 2.75rem;
          margin-bottom: 1rem;
        }
        .legal-body h2 .num {
          color: #FDE047;
          margin-right: 0.5rem;
        }
        .legal-body h3 {
          font-family: 'Barlow Condensed', sans-serif;
          font-weight: 700;
          font-size: 1.25rem;
          text-transform: uppercase;
          letter-spacing: 0.02em;
          color: #fafafa;
          margin-top: 1.75rem;
          margin-bottom: 0.5rem;
        }
        .legal-body ul {
          list-style: none;
          padding-left: 0;
        }
        .legal-body ul li {
          position: relative;
          padding-left: 1.25rem;
          margin-bottom: 0.5rem;
        }
        .legal-body ul li::before {
          content: "";
          position: absolute;
          left: 0;
          top: 0.55rem;
          width: 6px;
          height: 6px;
          background: #FDE047;
        }
        .legal-body strong { color: #fff; }
        .legal-body a { color: #FDE047; text-decoration: underline; text-underline-offset: 2px; }
        .legal-body a:hover { color: #fffa7c; }
      `}</style>
    </main>
  );
}
